import { NextPage } from "next";

import OwnerRegisterTask from "@/components/pages/owner/task/register";
import Auth from "components/shared/auth";
import CommonHead from "components/shared/commonHead";

const OwnerRegisterTaskPage: NextPage = () => {
  return (
    <>
      <CommonHead
        title="新規募集"
        description="COSOJI(こそーじ)は不動産管理業務における受発注や工程管理の仕組み及びデータ管理に加え各地域の工務店や作業員への発注（アウトソーシング）までをワンストップで行えるサービスです。"
        keyword="COSOJI,こそーじ"
        image="https://www.cosoji.jp/common/images/ogp/ogp_app.png"
      />
      <Auth userType="owner">
        <OwnerRegisterTask />
      </Auth>
    </>
  );
};

export default OwnerRegisterTaskPage;
